// extracted by mini-css-extract-plugin
export default {"labelContainer":"OK6oZO","label":"jTi7d2","labelIcon":"W1QLtV","categorySelect":"v93LG_"};